module.exports = __webpack_public_path__ + "static/media/open-sans-bold.5ee10d11.woff";